import { ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import useAnalytics from 'common/utils/hooks/useAnalytics';
import { TRACK_EVENTS } from 'constants/trackEvents';
import { StyledOptionsWrapper, StyledCheckbox } from '../style';
import useTexts from '../hooks/useTexts';
import { selectMergeOptions, MERGE_OPTIONS, toggleMergeOption } from '../slice';

const MergeOptions = (): ReactElement => {
  const dispatch = useDispatch();
  const { attachments, messages, notes, activities } = useTexts();
  const trackEvents = useAnalytics();

  const mergeOptions = useSelector(selectMergeOptions);

  const handleOptionClick = (e) => {
    switch (e.target.id) {
      case MERGE_OPTIONS.ATTACHMENTS:
        trackEvents(TRACK_EVENTS.MERGE_ATTACHMENTS_IN_SPECIFICATIONS_OVERLAY);
        break;
      case MERGE_OPTIONS.MESSAGES:
        trackEvents(TRACK_EVENTS.MERGE_MESSAGES_IN_SPECIFICATIONS_OVERLAY);
        break;
      case MERGE_OPTIONS.NOTES:
        trackEvents(TRACK_EVENTS.MERGE_NOTES_IN_SPECIFICATIONS_OVERLAY);
        break;
      case MERGE_OPTIONS.ACTIVITIES:
        trackEvents(TRACK_EVENTS.MERGE_ACTIVITIES_IN_SPECIFICATIONS_OVERLAY);
        break;
      default:
        break;
    }
    dispatch(toggleMergeOption(e.target.id));
  };

  return (
    <>
      <StyledOptionsWrapper data-testId="merge-options-wrapper">
        <StyledCheckbox htmlFor={MERGE_OPTIONS.ATTACHMENTS}>
          <input
            type="checkbox"
            checked={mergeOptions?.[MERGE_OPTIONS.ATTACHMENTS]}
            onClick={handleOptionClick}
            id={MERGE_OPTIONS.ATTACHMENTS}
          />
          {attachments}
        </StyledCheckbox>
        <StyledCheckbox htmlFor={MERGE_OPTIONS.MESSAGES}>
          <input
            type="checkbox"
            checked={mergeOptions?.[MERGE_OPTIONS.MESSAGES]}
            onClick={handleOptionClick}
            id={MERGE_OPTIONS.MESSAGES}
          />
          {messages}
        </StyledCheckbox>
        <StyledCheckbox htmlFor={MERGE_OPTIONS.NOTES}>
          <input
            type="checkbox"
            checked={mergeOptions?.[MERGE_OPTIONS.NOTES]}
            onClick={handleOptionClick}
            id={MERGE_OPTIONS.NOTES}
          />
          {notes}
        </StyledCheckbox>
        <StyledCheckbox htmlFor={MERGE_OPTIONS.ACTIVITIES}>
          <input
            type="checkbox"
            checked={mergeOptions?.[MERGE_OPTIONS.ACTIVITIES]}
            onClick={handleOptionClick}
            id={MERGE_OPTIONS.ACTIVITIES}
          />
          {activities}
        </StyledCheckbox>
      </StyledOptionsWrapper>
    </>
  );
};

export default MergeOptions;
